var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddInputCollectionMinuesBtn(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 771383"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 10848",
    x: 0.5,
    y: -0.5,
    width: 29,
    height: 27.2857,
    rx: 3.5,
    transform: "matrix(1 0 0 -1 0 27.2857)",
    fill: "white",
    stroke: "#CFDAE5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "+",
    d: "M20.5716 15.4253V13.1442H9.42871V15.4253H20.5716Z",
    fill: "#787A7B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddInputCollectionMinuesBtn);
export default __webpack_public_path__ + "static/media/addInputCollectionMinuesBtn.13eee7c23dc230057f40bcbb6881daf1.svg";
export { ForwardRef as ReactComponent };